<div class="card mx-2 shadow-sm">
  <div class="card-body">

    <!-- En-tête -->
    <div class="list-header d-flex justify-content-between align-items-center mb-3">
      <div class="list-info">
        <h6 class="mb-0 text-muted">
          <span tmwTranslate="tmw.auditHistory.title">Historique des modifications</span>
          <span class="ms-2 total-badge">(<span tmwTranslate="global.list.total">Total:</span> {{ totalCount }})</span>
        </h6>
      </div>
      <div class="list-actions d-flex align-items-center gap-2">
        <a
          *ngIf="!filtrer"
          (click)="filtrer = true"
          class="cursor-pointer"
          (mouseenter)="showTmwTooltip($event, 'Filtrer')"
          (mousemove)="moveTmwTooltip($event)"
          (mouseleave)="hideTmwTooltip()"
        >
          <i class="bi bi-search h5 mb-0"></i>
        </a>
        <div *ngIf="filtrer" class="input-group d-flex flex-nowrap" style="width: 220px">
          <input
            type="text"
            class="form-control form-control-sm"
            placeholder="Filtrer..."
            [(ngModel)]="term"
            autocomplete="off"
          />
          <button class="btn btn-primary btn-sm" type="button" (click)="term = ''; filtrer = false">
            <i class="bi bi-x"></i>
          </button>
        </div>
        <button
          class="btn btn-outline-secondary btn-sm"
          type="button"
          (click)="search()"
          (mouseenter)="showTmwTooltip($event, 'Actualiser')"
          (mousemove)="moveTmwTooltip($event)"
          (mouseleave)="hideTmwTooltip()"
        >
          <i class="bi bi-arrow-clockwise"></i>
        </button>
      </div>
    </div>

    <!-- Tableau -->
    <div class="table-responsive">
      <table class="table table-hover table-sm align-middle">
        <thead class="table-light">
          <tr>
            <th scope="col" style="width: 160px"><span tmwTranslate="tmw.auditHistory.dateTime">Date / Heure</span></th>
            <th scope="col" style="width: 100px"><span tmwTranslate="tmw.auditHistory.operation">Opération</span></th>
            <th scope="col" style="width: 140px"><span tmwTranslate="tmw.auditHistory.user">Utilisateur</span></th>
            <th scope="col"><span tmwTranslate="tmw.auditHistory.changedColumns">Colonnes modifiées</span></th>
            <th scope="col" style="width: 80px" class="text-center"><span tmwTranslate="tmw.auditHistory.detail">Détail</span></th>
            <th scope="col" style="width: 80px" class="text-center"><span tmwTranslate="tmw.auditHistory.revert">Revert</span></th>
          </tr>
        </thead>
        <tbody>
          @for (element of elements | tmwFilterBy: term; track element['auditId']) {
            <tr>
              <td>{{ element['auditDate'] | tmwDateTime }}</td>
              <td>
                <span class="badge" [ngClass]="badgeClass(element['operation'])">
                  {{ operationLabel(element['operation']) }}
                </span>
              </td>
              <td>{{ element['login'] }}</td>
              <td class="text-truncate" style="max-width: 250px" [title]="element['changedColumns']">
                {{ element['changedColumns'] }}
              </td>
              <td class="text-center">
                <button
                  class="btn btn-sm btn-outline-primary"
                  type="button"
                  (click)="openDetail(detailModal, element)"
                  (mouseenter)="showTmwTooltip($event, 'Voir le détail')"
                  (mousemove)="moveTmwTooltip($event)"
                  (mouseleave)="hideTmwTooltip()"
                >
                  <i class="bi bi-eye"></i>
                </button>
              </td>
              <td class="text-center">
                <button
                  *ngIf="canShowRevert(element['operation'], element['tableName'])"
                  class="btn btn-sm btn-outline-warning"
                  type="button"
                  [disabled]="revertingId === element['auditId']"
                  (click)="revertFromList(element)"
                  (mouseenter)="showTmwTooltip($event, 'Annuler cette opération (retour aux valeurs juste avant)')"
                  (mousemove)="moveTmwTooltip($event)"
                  (mouseleave)="hideTmwTooltip()"
                >
                  <span *ngIf="revertingId === element['auditId']" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                  <i *ngIf="revertingId !== element['auditId']" class="bi bi-arrow-counterclockwise"></i>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>

      <div *ngIf="!elements.length" class="row">
        <tmw-search-errorMessage></tmw-search-errorMessage>
      </div>

      <div *ngIf="totalCount > pageSize" class="d-flex justify-content-center p-2">
        <ngb-pagination
          [collectionSize]="totalCount"
          [pageSize]="pageSize"
          [(page)]="page"
          [maxSize]="5"
          [rotate]="true"
          [boundaryLinks]="true"
          (pageChange)="filter()"
        />
      </div>
    </div>

  </div>
</div>

<!-- Modal de détail — tableau de comparaison Avant / Après -->
<ng-template #detailModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="bi bi-clock-history me-2"></i>Détail de la modification
      <span *ngIf="selectedElement" class="ms-2 badge" [ngClass]="badgeClass(selectedElement['operation'])">
        {{ operationLabel(selectedElement['operation']) }}
      </span>
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body" *ngIf="selectedElement">

    <!-- Bloc méta -->
    <div class="row g-2 mb-3">
      <div class="col-6 col-md-3">
        <div class="audit-meta-card">
          <small class="text-muted">Date</small>
          <span>{{ selectedElement['auditDate'] | tmwDateTime }}</span>
        </div>
      </div>
      <div class="col-6 col-md-3">
        <div class="audit-meta-card">
          <small class="text-muted">Utilisateur</small>
          <span>{{ selectedElement['login'] || '—' }}</span>
        </div>
      </div>
      <div class="col-6 col-md-3">
        <div class="audit-meta-card">
          <small class="text-muted">Application</small>
          <span>{{ selectedElement['application'] || '—' }}</span>
        </div>
      </div>
      <div class="col-6 col-md-3">
        <div class="audit-meta-card">
          <small class="text-muted">Table</small>
          <span>{{ selectedElement['tableName'] }}</span>
        </div>
      </div>
      <div class="col-6 col-md-3">
        <div class="audit-meta-card">
          <small class="text-muted">ID enregistrement</small>
          <span>{{ selectedElement['recordId'] }}</span>
        </div>
      </div>
    </div>

    <!-- Badges colonnes modifiées -->
    <div *ngIf="selectedElement['changedColumns']" class="mb-3">
      <small class="text-muted fw-semibold me-2">Colonnes modifiées :</small>
      @for (col of (selectedElement['changedColumns'] || '').split(','); track col) {
        <span class="badge bg-warning text-dark border me-1 mb-1">{{ col.trim() }}</span>
      }
    </div>

    <!-- Fallback : JSON malformé → affichage brut -->
    <ng-container *ngIf="jsonParseError; else comparisonTable">
      <div class="alert alert-warning d-flex align-items-start gap-2 mb-3">
        <i class="bi bi-exclamation-triangle-fill mt-1 flex-shrink-0"></i>
        <div>
          <strong>Données non parsables</strong><br/>
          <small>Le JSON contient des caractères spéciaux non échappés.
            Régénérez les triggers d'audit pour corriger les futurs enregistrements.</small>
        </div>
      </div>
      <div class="row g-3">
        <div class="col-md-6" *ngIf="rawOldData">
          <div class="card border-danger h-100">
            <div class="card-header bg-danger text-white py-1 px-2">
              <small><i class="bi bi-dash-circle me-1"></i>Avant (OLD_DATA)</small>
            </div>
            <div class="card-body p-2">
              <pre class="mb-0 small raw-data-block">{{ rawOldData }}</pre>
            </div>
          </div>
        </div>
        <div class="col-md-6" *ngIf="rawNewData">
          <div class="card border-success h-100">
            <div class="card-header bg-success text-white py-1 px-2">
              <small><i class="bi bi-plus-circle me-1"></i>Après (NEW_DATA)</small>
            </div>
            <div class="card-body p-2">
              <pre class="mb-0 small raw-data-block">{{ rawNewData }}</pre>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Tableau de comparaison -->
    <ng-template #comparisonTable>
      <div class="table-responsive">
        <table class="table table-sm table-bordered align-middle mb-0 audit-compare-table">
          <thead class="table-dark">
            <tr>
              <th style="width: 28%">Colonne</th>
              <th class="text-center" style="width: 36%">
                <i class="bi bi-dash-circle me-1"></i>Avant
              </th>
              <th class="text-center" style="width: 36%">
                <i class="bi bi-plus-circle me-1"></i>Après
              </th>
            </tr>
          </thead>
          <tbody>
            @for (row of comparisonRows; track row.key) {
              <tr [class.table-warning]="row.changed">
                <!-- Colonne : gras si modifiée, monospace -->
                <td class="font-monospace small text-nowrap"
                    [class.fw-bold]="row.changed"
                    [class.fw-normal]="!row.changed">
                  <i *ngIf="row.changed" class="bi bi-pencil-fill text-warning me-1"></i>
                  {{ row.key }}
                </td>
                <!-- Valeur Avant -->
                <td class="small audit-cell" [class.text-danger]="row.changed && !!row.oldVal">
                  <span *ngIf="row.oldVal; else nullCell">{{ row.oldVal }}</span>
                  <ng-template #nullCell><em class="text-muted">—</em></ng-template>
                </td>
                <!-- Valeur Après -->
                <td class="small audit-cell" [class.text-success]="row.changed && !!row.newVal">
                  <span *ngIf="row.newVal; else nullCell2">{{ row.newVal }}</span>
                  <ng-template #nullCell2><em class="text-muted">—</em></ng-template>
                </td>
              </tr>
            }
            <tr *ngIf="!comparisonRows.length">
              <td colspan="3" class="text-center text-muted fst-italic py-3">
                <i class="bi bi-inbox me-1"></i>Aucune donnée disponible
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-template>

  </div>

  <div class="modal-footer d-flex justify-content-between align-items-center">
    <div>
      <button
        *ngIf="selectedElement && canShowRevert(selectedElement['operation'], selectedElement['tableName'])"
        type="button"
        class="btn btn-warning"
        [disabled]="revertLoading"
        (click)="revert(selectedElement['auditId'], modal)"
      >
        <span *ngIf="revertLoading" class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
        <i *ngIf="!revertLoading" class="bi bi-arrow-counterclockwise me-1"></i>
        {{ revertLoading ? 'Annulation en cours…' : 'Annuler cette opération' }}
      </button>
    </div>
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">
      <i class="bi bi-x-lg me-1"></i>Fermer
    </button>
  </div>
</ng-template>

<!-- Tooltip custom (position: fixed, indépendant ng-bootstrap) -->
@if (tmwTooltipVisible) {
  <div
    class="tmw-tooltip-popup"
    [style.left.px]="tmwTooltipX"
    [style.top.px]="tmwTooltipY - 44"
  >{{ tmwTooltipText }}</div>
}
